module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "blog"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))])]), _vm._v(" "), _c('c-paginate', {
    attrs: {
      "itemList": _vm.currentItems,
      "currentPage": _vm.currentPage,
      "totalItems": _vm.blog.totalItems,
      "requestNext": _vm.requestPage,
      "requestLast": _vm.requestPage
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-520a146d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Blog.vue
// module id = 266
// module chunks = 0